export const CO2_FACTOR = 0.4781 // t-CO2eq/MWh
